import { lazy } from 'react';

export const TasksPageLazy = lazy(() => import('./TasksPage'));
